import cn from 'classnames'
import Tab, { TabProps } from 'ext-ui/components/Tab/Tab'
import React, { ComponentProps, ReactElement } from 'react'
import { useSlidingNavBar } from 'src/hooks'

import style from './Subnav.style'

type SubnavProps = {
  className?: string
  tabs: TabProps[]
  severeTabs?: TabProps[]
} & ComponentProps<'div'>

function Subnav(props: SubnavProps): ReactElement {
  const { className = '', tabs, severeTabs, ...rest } = props

  const selectedIndex = props.tabs.reduce(
    (acc: number | undefined, curr, i) => (curr.active ? i : acc),
    undefined,
  )

  const { barStyle, containerDivRef } = useSlidingNavBar(
    selectedIndex,
    (el: HTMLElement) => ({
      left: el.offsetLeft,
      width: el.scrollWidth,
    }),
  )

  return (
    <div className={cn('Subnav', className)} css={style} {...rest}>
      <div className={cn('Subnav-tabs')} ref={containerDivRef}>
        {tabs.map((tab, i) => (
          <Tab key={i} {...tab} />
        ))}
        <div className={cn('Subnav-activeBar')} style={barStyle} />
      </div>
      <div className={cn('Subnav-tabs', 'severeTabs')}>
        {severeTabs?.map((tab, i) => (
          <Tab key={i} variant={'severe'} {...tab} />
        ))}
      </div>
    </div>
  )
}

export default Subnav
